<div class="card">
  <div class="card-body">
    <h5>{{ "Danh sách KH đăng ký SInvoice" | translate }}</h5>
    <div class="">
      <div class="row align-items-end">
        <div class="form-group col-lg-3 col-md-6">
          <div>
            <label for="validationCustom01">{{ "Email" | translate }}</label>
            <input
              type="tel"
              class="form-control"
              [(ngModel)]="filter.email"
              placeholder="Nhập email"
            />
          </div>
        </div>

        <div class="form-group col-lg-3 col-md-6">
          <label for="validationCustom01">{{
            "Số điện thoại" | translate
          }}</label>
          <input
            type="tel"
            class="form-control"
            [(ngModel)]="filter.phone"
            placeholder="Nhập số điện thoại"
          />
        </div>

        <!-- <div class="form-group col-lg-3 col-md-6">
                    <label for="statusFilter">{{ "Trạng thái" | translate }}</label>
                    <select id="statusFilter" class="form-control" [(ngModel)]="filter.status">
                        <option value="">Tất cả</option>
                        <option value="PAID">Đã thanh toán</option>
                        <option value="REGISTERED">Đã đăng ký</option>
                    </select>
                </div> -->

        <div class="col-lg-3 col-md-6">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Chọn khoảng ngày</mat-label>
            <mat-date-range-input [formGroup]="range" [rangePicker]="picker">
              <input
                matStartDate
                formControlName="start"
                placeholder="Ngày bắt đầu"
              />
              <input
                matEndDate
                formControlName="end"
                placeholder="Ngày kết thúc"
              />
            </mat-date-range-input>
            <mat-datepicker-toggle
              matSuffix
              [for]="picker"
            ></mat-datepicker-toggle>
            <mat-date-range-picker #picker></mat-date-range-picker>
            <mat-error
              *ngIf="range.controls.start.hasError('matStartDateInvalid')"
              >Invalid start date</mat-error
            >
            <mat-error *ngIf="range.controls.end.hasError('matEndDateInvalid')"
              >Invalid end date</mat-error
            >
          </mat-form-field>
        </div>
      </div>

      <div class="row mt-2">
        <div class="col-12">
          <button class="btn btn-primary" (click)="submitFilter()">
            <i class="ri-search-line"></i>
            {{ "PAGE.REPORT.Search" | translate }}
          </button>

          <button
            class="btn btn-dark ml-2"
            *ngIf="searching"
            (click)="clearFilter()"
          >
            <i class="ri-eraser-line"></i> {{ "FORM.Clear" | translate }}
          </button>
        </div>
      </div>
    </div>
    <div class="mt-4 d-flex justify-content-end">
      <!-- <button class="btn btn-info ml-2" (click)="downloadTemplate()">
        <i class="ri-download-2-line"></i> Tải file mẫu
      </button> -->
      <!-- <button class="btn btn-info ml-2" (click)="checkSelectedOrders()">
                <i class="ri-download-2-line"></i> Download dữ liệu đăng ký
            </button>
            <button class="btn btn-success ml-2" (click)="fileInput.click()">
                <i class="ri-upload-2-line"></i> Import dữ liệu
            </button> -->
      <input
        type="file"
        #fileInput
        hidden
        (change)="onFileSelected($event)"
        accept=".xlsx, .xls"
      />
    </div>
    <div class="table-responsive mt-3">
      <table
        id="basic-datatable"
        class="table table-bordered dt-responsive nowrap no-footer dtr-inline"
      >
        <thead>
          <tr class="bg-table">
            <!-- <th>
                            <input type="checkbox" [(ngModel)]="isAllSelected" (change)="toggleAllSelections()" />
                        </th> -->
            <th>#</th>
            <th
              *ngIf="
                role !== 'partner_operation' && role !== 'customer service'
              "
            >
              {{ "Quản lý" | translate }}
            </th>
            <th>{{ "Tên khách hàng" | translate }}</th>
            <th>{{ "SĐT " | translate }}</th>
            <th>{{ "Email " | translate }}</th>
            <th>{{ "Gói DV" | translate }}</th>
            <th>{{ "Mã giới thiệu" | translate }}</th>

            <th>{{ "Chủ tài khoản" | translate }}</th>
            <th>{{ "STK thanh toán" | translate }}</th>
            <th>{{ "Số tiền thanh toán" | translate }}</th>
            <th>{{ "Ngày thanh toán" | translate }}</th>

            <th>{{ "Trạng thái" | translate }}</th>
            <th>{{ "Loại đơn" | translate }}</th>
            <th>{{ "Ngày tạo" | translate }}</th>
          </tr>
        </thead>

        <tbody>
          <tr
            *ngFor="let data of listData; let i = index"
          >
            <!-- <td>
                            <input *ngIf="data.order_info?.status === 'PAID'" type="checkbox"
                                [(ngModel)]="data.selected" (change)="checkIfAllSelected()" />
                        </td> -->

            <td>{{ pageSize * (pageIndex - 1) + i + 1 }}</td>

            <td
              *ngIf="
                role !== 'partner_operation' && role !== 'customer service'
              "
            >
              <div class="d-flex align-items-center" style="gap: 0.5rem">
                <a
                  class="font-size-18 text-primary"
                  ngbTooltip="Tải xuống thông tin"
                  placement="top"
                  (click)="onDownload(data)"
                >
                  <i class="ri-download-2-line"></i>
                </a>
                <a
                  class="font-size-18 text-info"
                  ngbTooltip="Xem chi tiết"
                  placement="top"
                  (click)="getOrderDetails(data.id)"
                  >
                  <i class="ri-information-line"></i>
                </a>
                <!-- <a class="font-size-18 text-warning" ngbTooltip="Cập nhật trạng thái" placement="top"
                                    (click)="onEdit(data, content)">
                                    <i class="ri-refresh-line"></i>
                                </a> -->
              </div>
            </td>

            <td>{{ data.einvoice_register?.customer_name || "-" }}</td>
            <td>{{ data.einvoice_register?.phone || "-" }}</td>
            <td>{{ data.einvoice_register?.email || "-" }}</td>
            <td>
              {{ data.package_info?.invoice_package?.name || "-" }} +
              {{ data.package_info?.signature_package?.name || "-" }}
            </td>
            <td>
              {{ data.order_info?.code_rm || "Chưa có" }}
            </td>

            <td>{{ data.transaction_info.full_name || "-" }}</td>
            <td>{{ data.transaction_info.mb_funding_account || "-" }}</td>
            <td>{{ data.transaction_info.amount || "-" }}</td>
            <td>{{ data.transaction_info.paid_time || "-" }}</td>

            <td>
              <span
                class="badge"
                [ngClass]="statusPaymentColorMap[data.order_info?.status]"
              >
                {{ statusPaymentMap(data.order_info?.status) }}
              </span>
            </td>
            <td>
              <span *ngIf="data.transaction_type === 'renew'; else newType">
                {{ "Gia hạn" | translate }}
              </span>
              <ng-template #newType>
                {{ "Đơn mới" | translate }}
              </ng-template>
            </td>
            <td>
              {{ data.order_info?.created_at | date : "dd/MM/yyyy HH:mm" }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="row justify-content-md-between align-items-md-center mt-2">
      <div class="col-sm-12 col-md-5">
        <div
          class="dataTables_info mb-2"
          id="tickets-table_info"
          role="status"
          aria-live="polite"
        >
          {{ "TABLE.Showing" | translate }}
          {{ pageSize * pageIndex - pageSize + 1 }}
          {{ "TABLE.to" | translate }} {{ pageSize * pageIndex }}
          {{ "TABLE.of" | translate }} {{ totalCount }}
          {{ "TABLE.entries" | translate }}
        </div>
      </div>
      <div
        class="col-sm-12 col-md-7 d-flex align-items-center justify-content-end"
      >
        <div class="text-md-right float-md-right pagination-rounded">
          <ngb-pagination
            [collectionSize]="totalCount"
            [(page)]="pageIndex"
            [pageSize]="pageSize"
            [maxSize]="5"
            [ellipses]="true"
            (pageChange)="fetchData()"
          >
          </ngb-pagination>
        </div>
        <div class="dataTables_length ml-3" id="tickets-table_length">
          <label class="d-inline-flex align-items-center mb-0">
            {{ "TABLE.Show" | translate }}
            <select
              name="tickets-table_length"
              aria-controls="tickets-table"
              name="pageSize"
              [(ngModel)]="pageSize"
              (ngModelChange)="pageIndex = 1; fetchData()"
              class="custom-select custom-select-sm form-control form-control-sm mx-2"
            >
              <option [ngValue]="10">10</option>
              <option [ngValue]="25">25</option>
              <option [ngValue]="50">50</option>
              <option [ngValue]="100">100</option>
            </select>
            {{ "TABLE.entries" | translate }}
          </label>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #content role="document" let-modal="close">
  <div class="modal-header">
    <h5 class="modal-title">Cập nhật thông tin KH</h5>

    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body p-3">
    <div class="text-left">
      <form [formGroup]="formData" (ngSubmit)="onUpdateCustomer()">
        <div class="row">
          <div class="form-group row col-md-12">
            <label class="col-md-2 col-form-label required_label"
              >Tên tài khoản</label
            >
            <div class="col-md-10">
              <input
                type="text"
                class="form-control"
                formControlName="accountName"
                [ngClass]="{
                  'is-invalid':
                    submitted && formData.get('accountName')?.invalid
                }"
              />
            </div>
          </div>

          <div class="form-group row col-md-12">
            <label class="col-md-2 col-form-label required_label"
              >Mật khẩu</label
            >
            <div class="col-md-10">
              <input
                type="text"
                class="form-control"
                formControlName="accountPassword"
                [ngClass]="{
                  'is-invalid':
                    submitted && formData.get('accountPassword')?.invalid
                }"
              />
            </div>
          </div>

          <div class="form-group row col-md-12">
            <label class="col-md-2 col-form-label required_label"
              >Mã số thuế</label
            >
            <div class="col-md-10">
              <input
                type="text"
                class="form-control"
                formControlName="taxCode"
                [ngClass]="{
                  'is-invalid': submitted && formData.get('taxCode')?.invalid
                }"
              />
            </div>
          </div>

          <div class="form-group row col-md-12">
            <label class="col-md-2 col-form-label required_label"
              >Loại hóa đơn</label
            >
            <div class="col-md-10">
              <input
                type="text"
                class="form-control"
                formControlName="invoice_type"
                [ngClass]="{
                  'is-invalid':
                    submitted && formData.get('invoice_type')?.invalid
                }"
              />
            </div>
          </div>

          <div class="form-group row col-md-12">
            <label class="col-md-2 col-form-label required_label">Mẫu số</label>
            <div class="col-md-10">
              <input
                type="text"
                class="form-control"
                formControlName="template_code"
                [ngClass]="{
                  'is-invalid':
                    submitted && formData.get('template_code')?.invalid
                }"
              />
            </div>
          </div>

          <div class="form-group row col-md-12">
            <label class="col-md-2 col-form-label required_label"
              >Ký hiệu</label
            >
            <div class="col-md-10">
              <input
                type="text"
                class="form-control"
                formControlName="invoice_series"
                [ngClass]="{
                  'is-invalid':
                    submitted && formData.get('invoice_series')?.invalid
                }"
              />
            </div>
          </div>

          <div class="form-group row col-md-12">
            <label class="col-md-2 col-form-label required_label"
              >Loại hình kinh doanh</label
            >
            <div class="col-md-10">
              <select
                class="form-select form-control"
                formControlName="business_type"
                [ngClass]="{
                  'is-invalid':
                    submitted && formData.get('business_type')?.invalid
                }"
              >
                <option value="enterprise">Doanh nghiệp</option>
                <option value="household">Hộ kinh doanh</option>
              </select>
            </div>
          </div>
        </div>

        <div class="text-center">
          <button
            type="button"
            class="btn btn-secondary btn-lg mr-3"
            style="width: 150px"
            (click)="modal('close click')"
          >
            Đóng
          </button>
          <button
            type="submit"
            class="btn btn-success btn-lg"
            style="width: 150px"
          >
            Lưu
          </button>
        </div>
      </form>
    </div>
  </div>
</ng-template>


<ng-template #orderDetailModal role="document" let-modal="close">
  <div class="modal-header">
    <h5 class="modal-title">Chi tiết đơn hàng</h5>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div
    class="modal-body p-3"
    *ngIf="selectedOrder?.metadata?.accViettelInvoice"
  >
    <table class="table table-bordered table-sm">
      <tr>
        <th>Tên tài khoản</th>
        <td>{{ selectedOrder.metadata.accViettelInvoice.account_name }}</td>
      </tr>
      <tr>
        <th>Loại hình kinh doanh</th>
        <td>{{ selectedOrder.metadata.accViettelInvoice.business_type }}</td>
      </tr>
      <tr>
        <th>Ký hiệu hoá đơn</th>
        <td>{{ selectedOrder.metadata.accViettelInvoice.invoice_series }}</td>
      </tr>
      <tr>
        <th>Loại hoá đơn</th>
        <td>{{ selectedOrder.metadata.accViettelInvoice.invoice_type }}</td>
      </tr>
      <tr>
        <th>Mã số thuế</th>
        <td>{{ selectedOrder.metadata.accViettelInvoice.tax_code }}</td>
      </tr>
      <tr>
        <th>Mẫu hoá đơn</th>
        <td>{{ selectedOrder.metadata.accViettelInvoice.template_code }}</td>
      </tr>
    </table>
  </div>
</ng-template>
